'use client'

import { useEffect, useRef, useState } from "react"
import { useRouter } from "next/navigation"
import { reportError, useRouterForLink } from "@/(front-desk)/utils/functions"
import { handleCMS } from "@/(front-desk)/store"
import { useDispatch, useSelector } from "react-redux"
import { ArrowRightIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid"
// import { Pattern1, Pattern2, Pattern3 } from "@/(front-desk)/utils/patterns"
import Transition from "@/(front-desk)/components/Transition"
import classNames from "classnames"
import Link from "next/link"
import axios from "axios"
// import categoryDesign from '@/(front-desk)/assets/images/judges/design.png'
// import categoryAnimation from '@/(front-desk)/assets/images/judges/animation.png'
// import categoryGames from '@/(front-desk)/assets/images/judges/games.png'
// import categoryInter from '@/(front-desk)/assets/images/judges/inter.png'
// import categoryFilm from '@/(front-desk)/assets/images/judges/film.png'
// import defaultAvatar from '@/(front-desk)/assets/images/judges/default-avatar.png'
// import shine from '@/(front-desk)/assets/images/shine.png'


// const judgeCategoryImages = {
//     'DE': {
//         name: '設計類',
//         title: categoryDesign.src,
//         pattern: 
//             <Pattern1 className="w-[10rem] stroke-black-800 stroke-[0.5] fill-none" />
//     },
//     'AN': {
//         name: '動畫類',
//         title: categoryAnimation.src,
//         pattern: 
//             <img className="w-[10rem]" src={shine.src} alt="" />
//     },
//     'GA': {
//         name: '遊戲類',
//         title: categoryGames.src,
//         pattern: null
//     },
//     'IN': {
//         name: '跨域類',
//         title: categoryInter.src,
//         pattern: 
//             <div className="">
//                 <Pattern3 className="w-[11rem] stroke-main stroke-[0.3] fill-none" />
//                 <Pattern3 className="w-[3rem] ms-[10rem] mt-[-1rem] stroke-main stroke-1" />
//             </div>
//     },
//     'FI': {
//         name: '影視類',
//         title: categoryFilm.src,
//         pattern:
//             <Pattern1 className="w-[10rem] stroke-black-800 stroke-[0.5] fill-none" />
//     }
// }

export default function compete() {

    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)
    const global = useSelector((state) => state.global)
    const [ activeContent, setActiveContent ] = useState('guideline') // guideline
    const [ activeSection, setActiveSection ] = useState('timeline')
    // const [ imgsLoaded, setImgsLoaded ] = useState([])
    // const [ scrollY, setScrollY ] = useState(0)
    const sectionAreaRef = useRef()
    const router = useRouter()
    const prefetchedLinks = new Set();

    useEffect(() => {
        if (!CMS.competeDescription) {
            axios.get(`/api/v1/cms/zh_hant/posts?category=cms.join_competition.description`)
            .then((res) => {
                // console.log('join_competition success: ', res.data.body.results[0])
                dispatch(handleCMS.actions.setCompeteDescription(res.data.body.results[0]))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
        // if (!CMS.competeJudges) {
        //     axios.get(`/api/v1/cms/zh_hant/judges/2024`)
        //     .then((res) => {
        //         // console.log('judges success: ', res.data)
        //         dispatch(handleCMS.actions.setCompeteJudges(res.data.body))
        //     })
        //     .catch((err) => {
        //         // console.log(err.config?.url, err)
        //         reportError(err, true)
        //     })
        // }
        // window.addEventListener('scroll', handleScroll, false)

        // return() => {
        //     window.removeEventListener('scroll', handleScroll, false)
        // }
    }, [])

    useEffect(() => {
        if (CMS.competeDescription?.contents?.abstract) {
            const aEls = document.getElementById("section-content").querySelectorAll('a');
            useRouterForLink(aEls, prefetchedLinks, router)
        }
    }, [CMS.competeDescription])

    // useEffect(() => {
    //     if (CMS.competeJudges) {
    //         handleImgLoaded()
    //     }
    // }, [CMS.competeJudges])

    // function handleImgLoaded() {
    //     let imgList = []
    //     Object.keys(judgeCategoryImages).map((key) => {
    //         const judges = CMS.competeJudges.find((category) => category.shortcut === key)?.judges
    //         const titleSrc = judgeCategoryImages[key].title
    //         imgList.push(titleSrc)
    //         judges.map((judge) => {
    //             if (judge.info.avatar) {
    //                 imgList.push(judge.info.avatar)
    //             }
    //         })   
    //     })
    //     imgList.map((src) => {
    //         const img = new Image()
    //         img.src = src
    //         img.addEventListener("load", () => {
    //             setImgsLoaded(imgsLoaded => [...imgsLoaded, src])
    //         })
    //     })
    // }
    // function handleScroll(e) {
    //     setScrollY(window.scrollY)
    // }

    return (
        <>
        <title>競賽專區 - 放視大賞</title>
        <main className={classNames('compete', {
            'dark': activeContent === 'judges'
        })}>
            <div className="page-banner">
                <div className="page-banner-content">
                    {/* <div className="year leading-[100%]">{global.currentCompeteYear}</div> */}
                    <h1 className="title">Competition</h1>
                    {/* <h2 className="sub-title mb-12">{global.currentCompeteYear} 放視大賞 ＊ 競賽專區</h2> */}
                    <h2 className="sub-title mb-12">報名競賽</h2>
                    <div className="flex flex-wrap gap-4">
                        <Link
                            className="btn btn-main btn-round"
                            href={CMS.competeDescription?.contents.target_link ? CMS.competeDescription.contents.target_link : '/user/compete'}
                        >
                            前往報名
                            <ArrowTopRightOnSquareIcon className="w-5" />
                        </Link>
                        <Link className="btn btn-white btn-round" href="/download/procedure">
                            下載競賽簡章
                        </Link>
                    </div>
                </div>
            </div>
            <div id="main" className="content pt-10 pb-28">
                <div className="category-group">
                    <div className="scroll">
                        <button
                            className={`btn ${activeContent === 'guideline' ? 'active' : ''}`}
                            onClick={() => {setActiveContent('guideline')}}
                        >競賽辦法</button>
                        {/* <button
                            className={`btn ${activeContent === 'judges' ? 'active' : ''}`}
                            onClick={() => {setActiveContent('judges')}}
                        >評審團</button> */}
                    </div>
                </div>
                <div className={`bottom-area ${activeContent}`}>
                    <Transition transitionKey={activeContent}>
                        { activeContent === 'guideline' &&
                            <>
                            { CMS.competeDescription &&
                                <div className="guideline">
                                    <div className="side-bar">
                                        { CMS.competeDescription.contents.meta &&
                                            CMS.competeDescription.contents.meta.toc.map((sectionInfo, index) => {
                                                const handleActiveSection = () => {
                                                    setActiveSection(sectionInfo.id)
                                                    // sectionAreaRef.current.querySelector(`#${sectionInfo.id}`).scrollIntoView({behavior: "smooth"})
                                                    const element = sectionAreaRef.current.querySelector(`#${sectionInfo.id}`)
                                                    const positionY = element.getBoundingClientRect().top + window.scrollY - 100
                                                    window.scrollTo({top: positionY, behavior: 'smooth'})
                                                }
                                                const btnClass = classNames('btn', {
                                                    'active': activeSection === sectionInfo.id
                                                })
                                                const button = 
                                                    <button
                                                        key={`btn-${index}`}
                                                        className={btnClass}
                                                        onClick={handleActiveSection}
                                                    >{sectionInfo.text}</button>
                                                return button
                                        })}
                                    </div>
                                    <div className="section-area" ref={sectionAreaRef}>
                                        <div id="section-content" className="mb-8" dangerouslySetInnerHTML={{__html: CMS.competeDescription.contents.abstract}}></div>
                                        <Link
                                            className="btn btn-main btn-round w-fit"
                                            href={CMS.competeDescription.contents.target_link ? CMS.competeDescription.contents.target_link : '/user/compete'}
                                        >前往申請 <ArrowRightIcon className="w-5" /></Link>
                                    </div>
                                </div>
                            }
                            </>
                        }
                        {/* { activeContent === 'judges' &&
                            <div className="flex flex-col gap-10">
                                { CMS.competeJudges?.filter((category) => !category.is_enterprise).map((category, categoryIndex) => {
                                    const categoryEle = 
                                        <div className={classNames('flex flex-col', {
                                            'items-end': categoryIndex % 2 !== 0,
                                            'hidden': category.judges.length === 0
                                        })}>
                                            { judgeCategoryImages[category.shortcut]?.title &&
                                                <img
                                                    className={classNames('w-[33.75rem] transition', {
                                                        'opacity-[0]': !imgsLoaded.includes(judgeCategoryImages[category.shortcut].title)
                                                    })}
                                                    src={judgeCategoryImages[category.shortcut].title}
                                                    alt={`${judgeCategoryImages[category.shortcut].name}標題圖片`}
                                                />
                                            }
                                            <div
                                                className={classNames('pattern absolute hidden sm:block', {
                                                    'right-[-10rem]': categoryIndex % 2 === 0,
                                                    'left-[-10rem]': categoryIndex % 2 !== 0,
                                                })}
                                                style={{transform: `translateY(-${scrollY / 5}px)`}}
                                            >
                                                {judgeCategoryImages[category.shortcut]?.pattern}
                                            </div>
                                            <div className={classNames('judge-area flex flex-wrap gap-10 z-10', {
                                                'flex-row-reverse': categoryIndex % 2 !== 0
                                            })}>
                                                { category.judges.map((judge, judgeIndex) => {
                                                    const judgeEle = 
                                                        <div
                                                            key={`judge-${judgeIndex}`}
                                                            className={classNames('relative w-[15.5rem] text-center', {
                                                                'order-1': judge.is_convener,
                                                                'order-2': !judge.is_convener
                                                            })}
                                                        >
                                                            { judge.is_convener &&
                                                                <div className="absolute right-0 top-0 bg-black-800 w-fit flex gap-1 py-1 px-2 rounded-[0.25rem] rotate-12 z-[1]">
                                                                    <Pattern2 className="w-6 fill-black" />
                                                                    <div className="text-[1.125rem] text-white font-bold">召集人</div>
                                                                </div>
                                                            }
                                                            <Transition transitionKey={imgsLoaded.includes(judge.info.avatar)}>
                                                                <div className={classNames('w-full h-[11.25rem] rounded-[0.25rem] overflow-hidden mb-5', {
                                                                    'rounded-[1000rem]': judge.is_convener
                                                                })}>
                                                                    { (imgsLoaded.includes(judge.info.avatar) || !judge.info.avatar) 
                                                                        ?
                                                                        <img
                                                                            className="w-full h-full object-cover"
                                                                            src={judge.info.avatar ? judge.info.avatar : defaultAvatar.src}
                                                                            alt={`評審${judge.info.name}頭像`}
                                                                        />
                                                                        :
                                                                        <div className="w-full h-full bg-black-900 animate-pulse"></div>
                                                                    }
                                                                </div>
                                                            </Transition>
                                                            <div className="text-[1.5rem] text-white font-semibold mb-2">{judge.info.name}</div>
                                                            <div className="text-black-500 font-light mb-1">{judge.info.organization}</div>
                                                            <div className="text-black-500 font-light">{judge.info.title}</div>
                                                        </div>
                                                    return judgeEle
                                                })}
                                            </div>
                                        </div>
                                    return categoryEle
                                })}
                            </div>
                        } */}
                    </Transition>
                </div>
            </div>
        </main>
        </>
    )
}